define('drops/text/text',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/html',
    'lq/tooltip',
    'lq/onlongpress'
], function ($, lq, Drop, Style, util, html, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            text: 'New Text',
            useDynamicWidth: true,
            useDynamicHeight: true,
            openInline: false,
            scrollbarOnOverflow: false,
            title: {
                option: Tooltip.hardcoded
            },
            renderAsHtml: false,
            role: 'default',
            lineBreakAnywhere: false
        }
    };

    function Text(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$element
            .addClass('text-drop');

        if (this.data.scrollbarOnOverflow)
            this.$element.css('overflow-y', 'auto');

        Style.renderStyles(this);

        new OnLongPress().applyLongPressOnElement(this.$element, this);
        if (!this.designData && this.isEventEnabled('onLongPress')) {
            this.$element.addClass('clickable');
        }
        if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.$element.addClass('clickable');
        }
        if (this.data.lineBreakAnywhere) {
            this.$element.css({ lineBreak: 'anywhere' });
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');
        this.addEventsToBeCanceledAndCanceledBy('mouseEnter', 'mouseLeave');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    }

    Drop.extend(Text, Drop);

    Text.typeName = 'Text';

    Text.prototype.preRender = function () {
        this.rerenderText();
    };

    Text.prototype.rerenderText = function () {
        this.$text = this.createTextElement();
        this.$element.empty();
        this.$element
            .addClass('boxToBorderSize drop-text-container')
            // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
            .append($('<div />')
                .css({
                    display: 'flex',
                    whiteSpace: 'pre-wrap',
                    position: 'relative',
                    height: '100%',
                    width: '100%'
                })
                .append(this.$text));

        this.$text
            .addClass('drop-text-content')
            .css({
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 100%'
            });

        Style.renderStyles(this);
    };

    Text.prototype.createTextElement = function () {
        var text = this.data.text;
        var $textElement;

        if (this.data.role === 'title') {
            $textElement = $('<h1/>')
                .addClass('ignore-default-headings')
                .css({
                    height: '100%'
                });
        } else if (this.data.role === 'subtitle') {
            $textElement = $('<h2/>')
                .addClass('ignore-default-headings')
                .css({
                    height: '100%'
                });
        } else if (this.data.role === 'label') {
            $textElement = $('<label/>')
            .css({
                height: '100%'
            });

            var self = this;
            if (!this.designData) {
                $textElement
                    .attr('for', this.rootDrop.instanceId + '_' + this.data.labelForDropId)
                    .on('click', function (e) {
                        setTimeout(() => {
                            var element = document.getElementById(self.rootDrop.instanceId + '_' + self.data.labelForDropId);

                            // some targets can be focused through a <label /> (e.g. the Input) while other elements (e.g. the Multiselect) cannot
                            if (element && document.activeElement !== element) {
                                element.focus();
                            }
                        }, 0);
                    });
            }
        } else if (this.data.hyperlink && !this.designData) {
            $textElement = $('<a/>')
                .prop('href', util.convertRelativeHyperlinkToHostName(this.data.hyperlink))
                .prop('target', this.data.openInline ? '_self' : '_blank')
                .css({
                    height: '100%'
                });
        } else {
           $textElement = $('<div/>')
                .css({
                    height: '100%'
                });
        }

        if (this.data.renderAsHtml) {
            if (text) {
                var regex = new RegExp('{{{TenantUrl}}}', 'g');
                text = text.replace(regex, lq.getTenantUrl(''));
            }

            var $htmlWrapper = $('<div />')
                .html(html.sanitize(text) || '');

            return $textElement
                .append($htmlWrapper)
                .css('whiteSpace', 'normal');
        } else {
            return $textElement.text(text);
        }
    };

    Text.prototype.postRender = function () {
        this.tooltip.update();
        this.piping.visibility.apply(this);

        this.applyPosition();

        if (this.data.applyBestFontFit || false) {
            Style.bestFontSize(this.$element[0], this.$text);
        }
    };

    Text.prototype.postWindowResize = function () {
        if (this.data.applyBestFontFit || false) {
            Style.bestFontSize(this.$element[0], this.$text);
        }
    };

    return Text;
});
